var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 0.75C0.991748 0.75 0.166748 1.575 0.166748 2.58333C0.166748 3.59167 0.991748 4.41667 2.00008 4.41667C3.00841 4.41667 3.83341 3.59167 3.83341 2.58333C3.83341 1.575 3.00841 0.75 2.00008 0.75ZM2.00008 13.5833C0.991748 13.5833 0.166748 14.4083 0.166748 15.4167C0.166748 16.425 0.991748 17.25 2.00008 17.25C3.00841 17.25 3.83341 16.425 3.83341 15.4167C3.83341 14.4083 3.00841 13.5833 2.00008 13.5833ZM2.00008 7.16667C0.991748 7.16667 0.166748 7.99167 0.166748 9C0.166748 10.0083 0.991748 10.8333 2.00008 10.8333C3.00841 10.8333 3.83341 10.0083 3.83341 9C3.83341 7.99167 3.00841 7.16667 2.00008 7.16667Z",
    fill: "#948FB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.b934b25eaab512f3cf2fb330ff41ccf6.svg";
export { ForwardRef as ReactComponent };